import React, { memo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { TouchableOpacity } from 'react-native'

import { MenuItem } from '@ui-kitten/components'
import { Dots } from '../../../../../ui/molecules'
import { BtDropdown, BtText } from '@linqpal/components/src/ui'
import { RemoveInvoiceFromProject } from '../Modals/RemoveInvoiceFromProject'

import projectsStore from '../../../Store'

const RowAction = ({ item, projectId }) => {
  const { t } = useTranslation('global')

  const [modalVisible, setModalVisible] = useState(false)

  const { updateSelectedInvoices } = projectsStore

  return (
    <>
      <BtDropdown
        anchor={
          <TouchableOpacity>
            <Dots />
          </TouchableOpacity>
        }
      >
        <MenuItem
          testID={'projects-detail-remove-action'}
          onPress={() => {
            setModalVisible(true)
            updateSelectedInvoices({ selectedRows: [item] })
          }}
          title={() => <BtText>{t('Projects.RemoveInvoiceSo')}</BtText>}
        />
      </BtDropdown>

      <RemoveInvoiceFromProject
        item={item}
        projectId={projectId}
        modalVisible={modalVisible}
        setModalVisible={setModalVisible}
      />
    </>
  )
}

export default memo(RowAction)
